import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function useScrollToTop(): void {
  const { pathname } = useLocation();
  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.scrollTo(0, 0);
  }, [pathname]);
}
